import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { BASE_URL } from "../../../Config";

const ViewSinglePage = () => {
  const { id } = useParams();
  const [asana, setAsana] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchAsana = async () => {
    try {
      const token = sessionStorage.getItem("token");

      const res = await axios.get(`${BASE_URL}/allpages/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      });

      setAsana(res.data.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAsana();
  }, []);

  if (loading) return <p>Loading...</p>;

  if (!asana) return <p>No data found.</p>;

  return (
    <div style={{ padding: 20 }}>
      <h2>Alternative </h2>

      <div
        style={{
          padding: "15px",
          background: "#f9f9f9",
          borderRadius: 8,
          lineHeight: 1.6,
        }}
        dangerouslySetInnerHTML={{ __html: asana.content }}
      />
    </div>
  );
};

export default ViewSinglePage;
